import React from "react";
import logo from "../svg/logo2.png";
import ti from "../svg/ti.png";
import x3 from "../svg/x3.png";
import { Link } from "react-router-dom";

// import { useTranslation } from "react-i18next";

const PaymentSuccessful = () => {
  // const [t, i18n] = useTranslation("global");

  return (
    <div className="grid grid-cols-1  bg-black h-screen w-screen z-50 fixed top-0 left-0 right-0">
      <div className="grid grid-cols-1 p-6 bg-white w-9/12 flex place-self-center">
        <div className="grid grid-cols-2">
          <img className="h-16" src={logo} alt="logo" />
          <Link
            className="flex content-start justify-end flex-wrap"
            to="/tickets"
          >
            <img className="place-self-center h-2" src={x3} alt="logo" />
          </Link>
        </div>
        <img className="place-self-center h-10" src={ti} alt="logo" />
        <div className="place-self-center text-lg text-green-white">
          Your payment was successful!
        </div>
        <div className="place-self-center pb-16 text-lg text-center">
          You will receive your ticket on your email soon.
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccessful;
